import {createSlice, PayloadAction} from '@reduxjs/toolkit'
import {SLICE_BASE_NAME} from './constants'

export type TablesState = {
    columnsSettings?: object
}

export const initialState: TablesState = {
    columnsSettings: {},
}

export const tablesSlice = createSlice({
    name: `${SLICE_BASE_NAME}/tables`,
    initialState,
    reducers: {
        toggleColumn: (state, action: PayloadAction<any>) => {
            state.columnsSettings = state.columnsSettings || {}
            state.columnsSettings[action.payload.modelName] = state.columnsSettings[action.payload.modelName] || {}
            state.columnsSettings[action.payload.modelName][action.payload.columnName] = state.columnsSettings[action.payload.modelName][action.payload.columnName] || {}

            state.columnsSettings[action.payload.modelName][action.payload.columnName].hidden = !state.columnsSettings[action.payload.modelName][action.payload.columnName].hidden
        },
        setColumnsSettings: (state, action) => {
            state.columnsSettings = state.columnsSettings || {}
            state.columnsSettings[action.payload.modelName] = action.payload.columnsSettings
        },
    }
})

export const {
    toggleColumn,
    setColumnsSettings,
} = tablesSlice.actions

export default tablesSlice.reducer
